import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import moment from "moment";
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Redirect } from 'react-router-dom';
import LoadingSpinner from "../common/spinner/loading.component";
class LoadingSetup extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            progress: 0,
            message: '',
            redirect: '',
            onStepCompleted: this.props.onStepCompleted || function () { },
        }
        this.updateProgress = this.updateProgress.bind(this)
        this.isAccountExpired = this.isAccountExpired.bind(this)
        this.handleRedirect = this.handleRedirect.bind(this)
    }

    componentDidMount() {
        window.scrollTo(0,0)
        this.interval = setInterval(this.updateProgress, 150)
        this.state.onStepCompleted({})
    }

    updateProgress() {
        if (this.state.progress < 100) {
            let message = <FormattedMessage
                id="welcome.loading.progress_1"
                defaultMessage="Setting up your taxes..."
            />
            if (this.state.progress > 20) {
                message = <FormattedMessage
                    id="welcome.loading.progress_2"
                    defaultMessage="Setting up your company name and logo..."
                />
            }
            if (this.state.progress > 40) {
                message = <FormattedMessage
                    id="welcome.loading.progress_3"
                    defaultMessage="Configuring your default templates with your colors..."
                />
            }
            if (this.state.progress > 60) {
                message = <FormattedMessage
                    id="welcome.loading.progress_4"
                    defaultMessage="Configuring your modules..."
                />
            }
            if (this.state.progress > 80) {
                message = <FormattedMessage
                    id="welcome.loading.progress_5"
                    defaultMessage="Configuring your dashboard..."
                />
            }
            this.setState({
                progress : this.state.progress + 2,
                message : message,
            })
        } else {
            clearInterval(this.interval)
            this.setState({
                redirect: <Redirect to={'/congrats'} />
            })
        }
    }

    isAccountExpired() {
        const today = moment()
        const expirationDate = moment(AppContext.getAccount().attributes.expiredAt)
        const accountGracePeriodInDays = AppContext.getAccount().attributes.gracePeriodInDays
        const expirationDatePlusGracePeriod = moment(expirationDate).add(accountGracePeriodInDays, 'days')
        return expirationDatePlusGracePeriod < today
    }

  handleRedirect() {
    const currentPath = window.location.pathname;
    const redirectUrl = this.isAccountExpired() ? '/my-account' : '/congrats'
    if (currentPath !== redirectUrl) {
      return <Redirect to={redirectUrl} />;
    } else {
        setTimeout(() => {
            window.location.reload();
          }, 1250);
        return <LoadingSpinner/>
    }
  }
    render() {
        return (
            this.handleRedirect()

            //------> Not sure if we still want to keep to code in case

            // <div className="row py-0 justify-content-center pb-5">
            //     {this.state.redirect}
            //     <div className={"col-12 mb-4"}>
            //         <div className="row py-0 justify-content-center">
            //             <div className="col-lg-6 col-md-8 col-12">
            //                 <h1 className="text-center custom-lead text-custom-primary mb-0">
            //                     <FormattedMessage
            //                         id="welcome.loading.title"
            //                         defaultMessage="Give us a minute..."
            //                     />
            //                 </h1>
            //                 <p className="text-center">
            //                     <FormattedMessage
            //                         id="welcome.loading.description"
            //                         defaultMessage="We are setting up your account!"
            //                     />
            //                 </p>
            //             </div>
            //         </div>
            //     </div>
            //     <div className={'col-12'} style={{height: '350px'}}>
            //         <Robot />
            //     </div>
            //     <div className={'col-5'}>
            //         <p className={'mb-1 text-center'}>
            //             <small>{this.state.message}</small>
            //         </p>
            //         <ProgressBar progress={this.state.progress} />
            //     </div>
            //
            // </div>
        );
    }
}
export default injectIntl(LoadingSetup)


// WEBPACK FOOTER //
// ./src/onboarding/loadingsetup.component.jsx